import React from 'react';
import PropTypes from 'prop-types';
import Loader from './Loader';

const ContentLoader = (props) => {
	const {className, wrapperClassName, iClassName} = props;

	return (
		<div className={className}>
			<Loader wrapperClassName={wrapperClassName} iClassName={iClassName} />
		</div>
	);
};

ContentLoader.defaultProps = {
	className: 'content-wrapper overlay-wrapper',
	wrapperClassName: 'overlay',
	iClassName: 'fa fa-refresh fa-spin'
};

ContentLoader.propTypes = {
	className: PropTypes.string,
	wrapperClassName: PropTypes.string,
	iClassName: PropTypes.string
};

export default ContentLoader;